module.exports = __webpack_public_path__ + "img/arrow.aa298292.svg";